// import React from 'react';
// import { useSelector } from 'react-redux';
// import { Navigate, Outlet } from 'react-router-dom';
// import type { RootState } from './store';

// const ProtectedRoute: React.FC = () => {
//   const isLoggedIn = useSelector((state: RootState) => state.auth.isAuthenticated);

//   return isLoggedIn ? <Outlet /> : <Navigate to="/auth" replace />;
// };

// export default ProtectedRoute;

// import { useAppSelector } from "../store/store";
// import { Navigate } from "react-router-dom";

// export default function ProtectedRoute({ children }: any) {
//   const token = useAppSelector((state) => state.auth.access_token);

//   if (!token) return <Navigate to="/login" replace />;

//   return children;
// }


import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/store";
import { logout } from "../store/reducers/slices/authSlice";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({
  children,
}: any) {

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const token = useAppSelector(
    (state) => state.auth.access_token
  );


  useEffect(() => {

  if (!token) return;

  try {

    const decoded: any =
      jwtDecode(token);

    const currentTime =
      Date.now() / 1000;

    if (decoded.exp < currentTime) {

      dispatch(logout());

      localStorage.clear();

      navigate("/login");

    }

  } catch {

    dispatch(logout());

    localStorage.clear();

    navigate("/login");
  }

  }, [dispatch, navigate, token]);

  // useEffect(() => {

  //   if (!token) {

  //     dispatch(logout());

  //     navigate("/login", {
  //       replace: true,
  //     });
  //   }

  // }, [dispatch, navigate, token]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
